<template>
    <div id="app">
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex; align-items: center;height: 65px;margin-right: 15px;">
                    <div class="header-logo">
                        <img id="header-img" src="../assets/logo2.jpg" >
                    </div>
                </div>
                <div class="company_name">皓程蔚来科技有限公司</div>
            </div>
            <!-- <el-input placeholder="请输入" style="width: 300px"/>
            <el-button type="primary">搜索</el-button> -->
            <div style="flex:1;text-align: right;margin-right: 25px;"> 
                <el-button type="primary" @click="publicData">发布信息</el-button>
            </div>
            <div v-if="!$store.getters.mobile"> 
                <el-button type="text" @click="centerDialogVisible = true;">登录</el-button>
            </div>
            <div  v-else> 
                {{ $store.getters.username }}({{ $store.getters.mobile }})

                <el-tooltip content="退出登录">

                    <el-button type="text" @click="logout">
                        <i class="el-icon-switch-button" style="font-size: 20px;"></i>
                    </el-button>
                </el-tooltip>
                
            </div>
        </div>
        <div>
            <div id="menu_index">
                <el-dropdown @command="handleSelectT">
                    <el-button style="height: 60px;width: 120px;border: 0;border-radius: 0;" type="primary">
                        信息分类: 
                        <i class="el-icon-menu" style="color: white"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item v-for="(menu, index) in menus2" :key="menu.label" :command="menu" :index="index + ''">{{ menu.label }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                
                <!-- web端菜单导航 -->
                <el-menu :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333" style="border:0; background-color: #ececec;flex:1;display: flex;justify-content: space-between;" mode="horizontal" @select="handleSelect">
                    <el-menu-item :index="(index > 5) ? (index + 2 + '') : (index + '')" :key="menu.label" class="header-title" v-for="(menu, index) in menus">{{ menu.label }}</el-menu-item>
                </el-menu>
                
            </div>
        </div>
        <div class="container" style="clear: both;">
            <router-view></router-view>
        </div>

        <div style="width: 90%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div>
        <div style="width: 100%;padding: 40px 10% 10px; background-color: rgb(58, 58, 58); color: #fff;box-sizing: border-box;">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12">
                    <div>四川皓程蔚来科技有限公司</div>
                    <p class="footer_font" style="margin-top: 20px;">地址：中国（四川）自由贸易试验区天府新区兴隆街集萃街619号天府海创园2-2号楼17层</p>
                    <p class="footer_font">电话：18683251583</p>
                    <p class="footer_font">邮箱：86430436@qq.com</p>
                    
                </el-col>
                
                
            </el-row>
            <div style="margin: 20px auto 10px;text-align: center;font-size: 12px;color:rgb(153, 153, 153)" >
                ICP备案号：蜀ICP备2024073960号
            </div>
        </div>
        <!-- <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div> -->

        <el-dialog
            title="注册登录"
            :visible.sync="centerDialogVisible"
            width="30%"
            top="25vh"
            center>
            
            <div style="text-align: center;" slot="title">
                <div>注册登录</div>
                <div style="font-size: 13px;margin-top: 15px; color:#999">免费发布10条信息，再次发布信息需要收费，每条5元</div>
            </div>
            <el-form ref="ruleForm" :rules="rules" :model="form" label-width="80px">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="form.username"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="密码">
                    <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="login">确 定</el-button>
                <br>
                <span style="color: gray; font-size: 12px; margin-top: 15px;">首次登录默认为注册新用户</span>
            </span>
        </el-dialog>

        <PublishForm 
        :centerDialogVisible="showPublishForm"
        @close="closeAddForm"
        >
        </PublishForm>
    </div>
</template>

<script>
    import PublishForm from './PublishForm.vue'
    export default {
        name: "Layout",
        components: {
            PublishForm
        },
        data() {
            return {
                activeIndex: '0',
                menus: [{
                    label: '首页',
                    path: '/'
                }, {
                    label: '房屋租售',
                    path: '/rent'
                }, {
                    label: '二手转让',
                    path: '/transfer'
                }, {
                    label: '车辆买卖',
                    path: '/vich'
                }, {
                    label: '招聘信息',
                    path: '/order'
                }, {
                    label: '求职简历',
                    path: '/wantjob'
                }, {
                //     label: '宠物',
                //     path: '/pet'
                // }, {
                //     label: '生活服务',
                //     path: '/service'
                // },{
                    label: '关于我们',
                    path: '/about'
                },{
                    label: '联系我们',
                    path: '/contact'
                }],
                menus2: [{
                    label: '房屋租售',
                    path: '/rent'
                }, {
                    label: '二手转让',
                    path: '/transfer'
                }, {
                    label: '车辆买卖',
                    path: '/vich'
                }, {
                    label: '招聘信息',
                    path: '/order'
                }, {
                    label: '求职简历',
                    path: '/wantjob'
                }, {
                    label: '宠物',
                    path: '/pet'
                }, {
                    label: '生活服务',
                    path: '/service'
                }],
                centerDialogVisible: false,
                form: {
                    username: '',
                    mobile: '',
                    password: ''
                },
                rules: {
                    username: [{
                        validator: (rule, value, callback) => {
                            if (value === '' || value.trim() === '') {
                                callback(new Error('请输入用户名'));
                            } else {
                                callback();
                            }
                        }, 
                        trigger: 'blur'
                    }],
                    mobile: [{
                        validator: (rule, value, callback) => {
                            if (value === '' || value.trim() === '') {
                                callback(new Error('请输入手机号'));
                            } else {
                                callback();
                            }
                        }, 
                        trigger: 'blur'
                    }],
                    password: [{
                        validator: (rule, value, callback) => {
                            if (value === '' || value.trim() === '') {
                                callback(new Error('请输入密码'));
                            } else {
                                callback();
                            }
                        }, 
                        trigger: 'blur'
                    }]
                },
                showPublishForm: false
            };
        },
        methods: {
            handleSelect(key) {
                this.$router.push(this.menus[key >= 8 ? (key - 2) : key].path || '/')
            },
            handleSelectT(menu) {
                this.$router.push(menu.path || '/')
            },
            handleSelectMobile(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        break;
                    case '2':
                        this.$router.push({name: "About"});
                        break;

                    case '3':
                        this.$router.push({name: "Service"});

                        break;
                    case '4':
                        this.$router.push({name: "Contact"});
                        break;
                }
            },
            
            logoClick(){
                this.$router.push({name: "Index"});
            },
            login() {
                this.$refs['ruleForm'].validate((valid) => {
                if (valid) {

                    this.$store.commit('login', {
                        username: this.form.username,
                        mobile: this.form.mobile
                    })
                    this.centerDialogVisible = false
                } else {
                    // console.log('error submit!!');
                }
                });
                
            },
            logout() {
                this.$store.commit('logout')
            },
            publicData() {
                if (!this.$store.getters.mobile) {
                    this.centerDialogVisible = true
                    return 
                } else {
                    this.showPublishForm = true

                }
            },
            closeAddForm() {
                this.showPublishForm = false;
            }
        },
        mounted() {
            // window.addEventListener('scroll', this.handleScroll)
            this.activeIndex = ['Index', 'Rent', 'Transfer', 'Vich', 'Order', 'Wantjob', 'Pet', 'Service', 'About', 'Contact'].indexOf(this.$route.name) + ''
        },
        watch: {
            $route(newVal) {
                this.activeIndex = ['Index', 'Rent', 'Transfer', 'Vich', 'Order', 'Wantjob', 'Pet', 'Service', 'About', 'Contact'].indexOf(newVal.name) + ''
            }
        }
    }
</script>

<style scoped>

    #app {
        min-width: 1000px;
    }
    .logo_img{
        width: 25%;
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        font-size: 1em;
        width: 120px;
        text-align: center;
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    .footer_font{
        margin: 5px 0;
        font-size: 14px;
        color: rgba(205, 205, 205, 1);

    }
    #menu_index{
        display: flex;
        align-items: center;
        padding: 0 10vw;
        background: #ececec;
    }
    .header{
        padding: 20px 0 ;
        display: flex;
        align-items: center;
        margin: auto;
        width: 90%;
        height: 105px;
        /*background: #F56C6C;*/
    }
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            margin: 10px 0;
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
        .mobile_menu{

        }
    }
    #header-img{
        width: 50px;
        height: 50px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
  

    .footer{
        display: flex;
        align-items: center;
        margin: 10px auto;
        width: 90%;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
</style>
<style>
    .page-header {
        position: relative;

    }
    .page-header img {
        width: 100%;
        height: 500px;
        object-fit: cover;
    }

    .page-header-content {
        position: absolute;
        z-index: 1;
        left: 20%;
        top: 20% 
    }
</style>